export const COMMON_DEFAULT_PAGE_SIZE = 20;
